import * as yup from 'yup';

const ApproachSchema = yup.object({
  description: yup.string().required('Approach is required'),
});

export { ApproachSchema };
